import { render, staticRenderFns } from "./MySetUI.vue?vue&type=template&id=50f323ce&"
import script from "./MySetUI.vue?vue&type=script&lang=js&"
export * from "./MySetUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports